module.exports = "/_next/static/fonts/ABCSocial-Regular-edb7322dcfd4a3e27be5b75f2c8bb774.woff2";